import React from 'react';
import { motion } from 'framer-motion';

const StaticContentPage = ({ title, lastUpdated, children }) => {
  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-8 md:py-12 text-center md:text-left">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-3xl border border-gray-100 p-8 md:p-16 shadow-sm flex flex-col items-center md:items-start"
      >
        <div className="w-full max-w-3xl">
          {(title || lastUpdated) && (
            <div className="mb-10 text-center md:text-left">
              {title && (
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight mb-4">
                  {title}
                </h1>
              )}
              {lastUpdated && (
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-[0.15em]">
                  Last Updated: {lastUpdated}
                </p>
              )}
            </div>
          )}
        </div>

        <div className="w-full max-w-3xl prose prose-blue prose-lg max-w-none prose-headings:font-bold prose-headings:tracking-tight prose-headings:text-gray-900 prose-p:text-gray-600 prose-p:leading-relaxed prose-li:text-gray-600 prose-strong:text-gray-900">
          {children}
        </div>
      </motion.div>
    </div>
  );
};

export default StaticContentPage;
